import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';
import { JwtService } from '../../core/auth/jwt.service';
import { MultiSesionService } from '../../core/auth/multi-sesion.service';

/**
 * Entrada por defecto: manda a la primera sesion vigente del navegador o,
 * si no hay ninguna, al login de FrontKordata.
 */
@Component({
  selector: 'app-redirect',
  template: `
    <p class="visually-hidden" role="status">Redirigiendo</p>
  `,
})
export class RedirectComponent {
  private readonly router = inject(Router);
  private readonly multiSesion = inject(MultiSesionService);
  private readonly jwt = inject(JwtService);
  private readonly auth = inject(AuthService);

  constructor() {
    const indice = this.multiSesion
      .sesiones()
      .findIndex(sesion => !this.jwt.isTokenExpired(sesion.token));

    if (indice >= 0) {
      this.router.navigate([`/${indice}/main`], { replaceUrl: true });
      return;
    }

    this.auth.irALoginDeKordata();
  }
}
